import { render, staticRenderFns } from "./CustomizationOfferCreateAdmin.vue?vue&type=template&id=b3c08ed4&scoped=true"
import script from "./CustomizationOfferCreateAdmin.vue?vue&type=script&lang=js"
export * from "./CustomizationOfferCreateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c08ed4",
  null
  
)

export default component.exports